// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminIdentityUserMemberships = {
  drawers: {
    membership: "授权 · {name}",
    membershipShort: "授权",
  },
  alerts: {
    membershipEditMode:
      "当前抽屉支持平台角色全量编辑：保留已选角色、可新增角色，也可通过取消勾选移除已有角色。提交时按差量新增和删除。",
    membershipNoExistingRoles: "当前还没有已分配的平台角色。",
  },
  confirms: {
    removeMembershipTitle: "删除平台角色绑定",
    removeMembershipDescription: "确认删除 {value} 吗？",
  },
  messages: {
    membershipRemoved: "平台角色绑定已删除",
    membershipRemoveFailed: "删除平台角色绑定失败",
    membershipCreated: "平台角色分配已完成，新增 {count} 个角色，跳过 {skippedCount} 个已有角色",
    membershipCreatedWithPartialFailures:
      "平台角色分配部分完成：新增 {successCount} 个，跳过 {skippedCount} 个，失败 {failedCount} 个：{details}",
    membershipCreateFailed: "平台角色分配失败",
    membershipCreateFailedForRole: "平台角色分配失败：{role}",
    membershipAllRolesAlreadyAssigned: "所选平台角色都已存在，无需重复分配",
    membershipUpdated:
      "用户授权已更新，新增 {createdRoleCount} 个平台角色，移除 {removedRoleCount} 个平台角色，新增 {createdOrganizationMembershipCount} 条组织归属，移除 {removedOrganizationMembershipCount} 条组织归属",
    membershipUpdatedWithPartialFailures:
      "用户授权部分更新：新增 {createdRoleCount} 个平台角色，移除 {removedRoleCount} 个平台角色，新增 {createdOrganizationMembershipCount} 条组织归属，移除 {removedOrganizationMembershipCount} 条组织归属，失败 {failedCount} 个：{details}",
    membershipUpdateFailed: "平台角色分配更新失败",
    membershipRemoveFailedForRole: "平台角色移除失败：{role}",
    membershipNoChanges: "平台角色和组织归属都未发生变化",
    organizationMembershipContextUnavailable:
      "当前无法确定组织主体，请先完成组织初始化后再维护组织归属",
    organizationMembershipCreateFailed: "组织归属新增失败",
    organizationMembershipRemoveFailedForUnit: "组织归属移除失败：{unit}",
  },
  forms: {
    organizationMembershipsHint: "这里维护的是用户真实组织归属，支持同时挂到多个组织节点。",
    organizationMembershipsUnavailable: "当前还没有可维护的组织主体，请先在组织页初始化组织树。",
  },
} as const;
